import { buildSvgPath } from "@/scripts/common/svg-path";

document.addEventListener("DOMContentLoaded", () => {
  const pathContainer = document.body;

  const getPathPoints = () => {
    const pageHeaderLeadIn = pathContainer.querySelector(".page-header-lead-in");
    const pageHeaderLeadInRect = pageHeaderLeadIn.getBoundingClientRect();
    const teamSection = pathContainer.querySelector(".section-team");
    const teamSectionRect = teamSection.getBoundingClientRect();

    const points = [];

    if (!window.matchMedia("(min-width: 768px)").matches) {
      return points;
    }

    points.push({ x: pageHeaderLeadInRect.x + 24, y: pageHeaderLeadInRect.y + pageHeaderLeadInRect.height });
    points.push({ x: pageHeaderLeadInRect.x + 24, y: teamSectionRect.y + teamSectionRect.height });
    points.push({ x: window.innerWidth - teamSectionRect.x, y: teamSectionRect.y + teamSectionRect.height });

    return points;
  };

  const handleSvgPath = () => {
    const pathPoints = getPathPoints();

    buildSvgPath(pathContainer, pathPoints, { gradientId: "page-line-gradient-faded" });
  };

  const resizeObserver = new ResizeObserver(() => requestAnimationFrame(handleSvgPath));
  resizeObserver.observe(document.body);
});
